import React, { Component } from "react";
import axios from "axios";
import $ from 'jquery';
import moment from 'moment';
import { isSafari as safari, isChrome as chrome, isEdge as edge, isMobileOnly as mobileOnly, isTablet as tablet, osName as osname, browserName as browName} from "react-device-detect";
import FmsNotes from "./FmsNotes";
import isEmpty from "is-empty";
class ParticipantControls extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			sessionTime: '00 : 00 : 00',
			isElectron: window['electron'],
			openAudioControls: false,
			openVideoControls: false,
			cameraDisableArray: [],
			openTestingMic: false,
			isPlayedSpeaker: 0,
			microphoneTestPart: 'start',
			isPlayedAudio: 0,
			speakerTestPart: 'start',
			isEndedSession: false,
			openMoreControls: false,
			audioInstruction: '',
			boxingPosition: '',
			bagPosition: window['bagPosition'],
			currentUserData: JSON.parse(localStorage.getItem('userData')),
			currentResolution: 'sd',
		    boxJumpSize: '',
		    boxJumpOptions: [7, 10, 12, 14, 16],
		    hasBoxJump: false,
			showBigClock: false,
			countSecs: 10,
			volumeHost: JSON.parse(localStorage.getItem('userData')).default.memberHostVolumeD2c ? JSON.parse(localStorage.getItem('userData')).default.memberHostVolumeD2c : 50,
			volumeFM: JSON.parse(localStorage.getItem('userData')).default.memberFeedFmVolumeD2c ? JSON.parse(localStorage.getItem('userData')).default.memberFeedFmVolumeD2c : 25,
			hideFmControls: false,
			boxingCirclePosition: window['boxingCirclePosition'],
			hasBoxing: false,
			boxJumpWidth: window['boxSelW'],
			boxJumpHeight: window['boxSelH'],
		}
		
		this.xInterval = null;
		this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
		this.startTimeRTM = null;
		this.startTimeRTMSeconds = null;
		this.rtmCodes = {};
		this.endReplayCalled = false;
		this.previousRTMTime = '';
		this.loadedVideo = false;
		
		window['updateStateControls'] = this.updateStateControls;
		window['applyCameraRestrict'] = this.applyCameraRestrict;
		window['currentUserData'] = this.state.currentUserData;
		window['showHideVolume'] = this.showHideVolume;
	}
 
	componentDidMount(){
		console.log('ParticipantControls');
		if ( localStorage.getItem('userData') ) 
			{
				if ( this.state.isElectron ) { this.getVideoResolution(); }
				var mainData = JSON.parse(localStorage.getItem('userData'));
				
				if ( mainData && mainData.sessionData && mainData.sessionData.ejectedUser )
					{
						localStorage.removeItem("userData");
						window.location.href = '/login';
					}
				
				let currDate = new Date(mainData.sessionData.scheduleDate);
				console.log('currDate111', currDate);
				if ( this.state.currentUserData.sessionData.ondemandId > 0 ) { currDate = new Date(); console.log('currDate222', currDate); }
				currDate.setMinutes(currDate.getMinutes() + mainData.sessionData.duration);
				var setAudioType = mainData.virtualInstructions;
				if ( !setAudioType ) { setAudioType = window['audioType'] == 'longAudio' ? 1 : window['audioType'] == 'shortAudio' ? 2 : 0; }
				
				var setBoxingType = mainData.boxingPosition;
				if ( !setBoxingType ) { setBoxingType = window['boxingType'] == 'ninetyDegrees' ? 1 : 0; }
				
				window['audioType'] = setAudioType == 1 ? 'longAudio' : setAudioType == 2 ? 'shortAudio' : 'offAudio';
				window['boxingType'] = setBoxingType == 1 ? 'ninetyDegrees' : 'fourtyFiveDegrees';
				
				if ( mainData.sessionData.scriptDetail.length > 0 )
					{
						var isFoundEquipment = false;
						var activity = mainData.sessionData.scriptDetail;
						for ( var i = 0; i < activity.length; i++ )
							{
								for ( var a = 0; a < activity[i].attribute.length; a++ )
									{
										/* if ( activity[i].attribute[a].attrLabel === 'Activity Type' )
											{
												if ( activity[i].attribute[a].attrValue === 'Virtual Assistant' || activity[i].attribute[a].attrValue === 'Virtual Equipment' )
													{
														isFoundEquipment = true;
													}
											} */
											
										if ( activity[i].name == 'Box Horizontal' )
											{
												this.setState({ hasBoxJump: true });
											}
										else if ( activity[i].name == 'Boxing Bag 1' || activity[i].name == 'Boxing Bags 2 - NEW' )
											{
												this.setState({ hasBoxing: true });
											}
									}
							}
					}
				if ( mainData.sessionData.replayClassId > 0 || mainData.sessionData.ondemandId > 0 )
					{	
						var host_stream = document.getElementById('host_stream');
						var replayClassElement = document.getElementById('replayClassVideo');
						host_stream.append(replayClassElement);
						var rtmCodesArray = mainData.sessionData.rtmCodes;
						var rtmCodesObject = {};
						
						if ( rtmCodesArray )  
							{
								for ( var i = 0; i < rtmCodesArray.length; i++ )
									{
										var currentRTMCode = JSON.parse(rtmCodesArray[i]['rtmCode']);
										for ( var index in currentRTMCode )
											{
												if ( mainData.sessionData.ondemandId > 0 && !this.startTimeRTM ) 
													{
														for ( var b = 0; b<currentRTMCode[index].length; b++ )
															{
																if ( currentRTMCode[index][b].indexOf("217~@$") > -1 ) 
																	{
																		this.startTimeRTM = index;
																		console.log('currentRTMCode[index] found start', this.startTimeRTM);
																	}
															}
													}
												
												if ( !rtmCodesObject[index] )
													{
														rtmCodesObject[index] = currentRTMCode[index];
													}
											}
									}
							}
						this.rtmCodes = rtmCodesObject;
						//JSON.parse(currentUserData.sessionData.rtmCodes[0].rtmCode)
						console.log(this.rtmCodes, 'rtmCodes');
					}
					
				/*if ( mainData.sessionData.ondemandId > 0 )
					{
						var videoReplay = document.getElementById("video-element");
						var videoURL =  mainData.sessionData.videoPath;
						videoReplay.setAttribute("src", videoURL);
						videoReplay.oncanplay = function (){
							videoReplay.play();
						}
					}*/
					
				this.setState({
					audioInstruction: window['audioType'],
					boxingPosition: window['boxingType']
				},()=>{ console.log(this.state.audioInstruction, this.state.boxingPosition, 'AUDIO_INSTRUCTIONS'); });
				this.countdownTimer(currDate);
			}
		
		let cameraDisableStatus = [];
		if ( localStorage.getItem('turnOfCamera') )
			{
				cameraDisableStatus = JSON.parse(localStorage.getItem('turnOfCamera'));
				
				if ( cameraDisableStatus.indexOf("Me (I dont't want to see myself)") > -1 ) 
					{ 
						$('#mine_stream').addClass('d-none');
						$('.video_icon .muted_audio').removeClass('d-none');
					}
				
				this.setState({cameraDisableArray: cameraDisableStatus})
			}
		
		this.getBoxingPosition();
		document.addEventListener('mousedown', this.handleClickOutside);
		this.applyCameraRestrict();
	}
	
	componentWillUnmount(){
		clearInterval(this.xInterval);
		document.removeEventListener('mousedown', this.handleClickOutside);
	}
	
	updateStateControls=(state)=>{
		this.setState(state);
	}
	
	handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
           this.setState({openAudioControls: false, openVideoControls: false, openTestingMic: false, openMoreControls: false});
        }
    }
	
	showHideVolume=(mod)=>{
		this.setState({hideFmControls: mod});
	}
	
	countdownTimer=(sessionDate)=>{
		var deadline = 0;
		var sessionData = JSON.parse(localStorage.getItem('userData')).sessionData;

		if ( JSON.parse(localStorage.getItem('userData')).sessionData.isTutorialRead > 0 ) 
			{
				let seconds = JSON.parse(localStorage.getItem('userData')).default.defaultSessionDuration * 60;
				let currDate = new Date();
				currDate.setSeconds(currDate.getSeconds() + seconds);
				deadline = new Date(currDate).getTime();
			} 
		else 
			{
				deadline = new Date(sessionDate).getTime();
			}
			
		var startDate = moment(sessionData.scheduleDate).format("MM/DD/YYYY hh:mm");
		
		var now,
        timeRemaining,
        hours,
        minutes,
        seconds,
		hoursRep,
        minutesRep,
        secondsRep,
		timeToStartClass;

		let sessionStartTime = new Date(JSON.parse(localStorage.getItem('userData')).sessionData.scheduleDate).getTime();

		var isFoundStart = false;
		var startClassTime = 0;

		var mainthis = this;
		this.xInterval = setInterval(function() {
            now = new Date().getTime();
            timeRemaining = deadline - now;
			timeToStartClass = sessionStartTime - now;
			var timeCurrent = '';
			var timeCurrentRep = '';
			
			if ( sessionData.replayClassId === 0 )
				{
					let timeToStart = sessionStartTime - now;
					timeToStart = timeToStart / 1000;
					if ( timeToStart > 0 && timeToStart < 11  )
						{
							if ( mainthis.state.showBigClock == false )
								{
									//mainthis.showBigCountdown(timeToStart);
								}
									
						}								
					else 
						{
							mainthis.setState({showBigClock: false});
						}
				}
            if (timeRemaining < 0 && !sessionData.ondemandId) 
				{ 
					clearInterval(mainthis.xInterval);
					mainthis.setState({sessionTime: 'Class Ended', isEndedSession: true});
					if ( localStorage.getItem('groupClass') !== null )
						{
							var sendData = JSON.parse(localStorage.getItem('groupClass'));
							let token = JSON.parse(localStorage.getItem('userData')).token;
							axios.defaults.headers.common['Authorization'] = token;
							axios.post(process.env.REACT_APP_API_URL+'/api/v1/programs/classCompleted', sendData).then(res => {
								$('.main_loader').hide();
							}).catch(err =>{ });   
						}
				} 
			else 
				{
					var timeToUse = timeRemaining;
					var timeToUseRep = timeRemaining;
					
					if ( timeToStartClass && timeToStartClass > 0 )
					{
							timeToUse = timeToStartClass;
							
							if ( sessionData.replayClassId > 0 )
								{
									timeToUseRep = timeToStartClass+(JSON.parse(localStorage.getItem('userData')).sessionData.duration*60*1000);
									
									secondsRep = ("0" + (Math.floor((timeToUseRep / 1000) % 60) % 60)).slice(-2);
									minutesRep = ("0" + Math.floor((timeToUseRep / 60000) % 60)).slice(-2);
									hoursRep = Math.floor((timeToUseRep / 3600000));
									
									if(hoursRep >= 100) {
									  hoursRep = ("0" + hoursRep).slice(-3);
									} else {
									  hoursRep = ("0" + hoursRep).slice(-2);
									}
								}
						}
						
					seconds = ("0" + (Math.floor((timeToUse / 1000) % 60) % 60)).slice(-2);
					minutes = ("0" + Math.floor((timeToUse / 60000) % 60)).slice(-2);
					hours = Math.floor((timeToUse / 3600000));
					
					if(hours >= 100) {
					  hours = ("0" + hours).slice(-3);
					} else {
					  hours = ("0" + hours).slice(-2);
					}
					
					
					let time = hours + ' : ' + minutes + ' : ' + seconds;
					if ( JSON.parse(localStorage.getItem('userData')).isMarketplaceChannel && JSON.parse(localStorage.getItem('userData')).isMarketplaceChannel == 1 )
						{
							time = minutes + ' : ' + seconds;
						}
					
					var hoursToMinutes = parseInt(hours) * 60;
					var fullMinutes = hoursToMinutes + parseInt(minutes);
					
					timeCurrent = fullMinutes+":"+seconds;
					timeCurrentRep = ('0'+fullMinutes).slice(-2)+':'+('0'+seconds).slice(-2);
					
					mainthis.setState({sessionTime: time});
				}
				
			if ( ( sessionData.replayClassId > 0 || sessionData.ondemandId > 0 ) && !window['clickedOnLogout'] )
				{	
					if ( timeToStartClass && timeToStartClass > 0 )
						{
							hours = hoursRep;
							minutes = minutesRep;
							seconds = secondsRep;
						}
					
					var hoursMinutes = parseInt(hours) * 60;
					var currentMinutes = parseInt(minutes) + hoursMinutes;
					var currentSeconds = parseInt(seconds);
					var fullSecondsCurrent = (currentMinutes * 60) + currentSeconds;
					
					if ( timeToStartClass && timeToStartClass > 0 )
						{
							timeCurrent = currentMinutes+":"+seconds;
							timeCurrentRep = ('0'+currentMinutes).slice(-2)+':'+('0'+seconds).slice(-2);
						}
					
					var currentDate = moment(new Date()).format("MM/DD/YYYY hh:mm");
					var videoReplay = '';
					if ( document.getElementById("replayClassVideo") )
						{
							videoReplay = document.getElementById("replayClassVideo");
						}
					else 
						{
							return false;
						}						
					
					var swappedVideoTime = videoReplay.currentTime;
					if ( window['streamSwapped'] )
						{
							/* videoReplay = document.getElementById("replayClassVideoSwap");
							if ( videoReplay.src == "" ) { isFoundStart = false; mainthis.loadedVideo = false; } */
	 					}
					var isPlayedVideo = false;
					var checkSessionCompleted = 1;
					
					if ( sessionData.ondemandId > 0 && mainthis.startTimeRTM )
						{
							var parts = mainthis.startTimeRTM.split(':'),
								minutes = +parts[0],
								seconds = +parts[1];
							var startTimeOnDemand = (minutes * 60 + seconds);
							var videoTime = videoReplay.currentTime ? parseInt(videoReplay.currentTime) : 0;
							var currentTimeOnDemand = startTimeOnDemand - videoTime;
							var currentTimeMinutes = Math.floor(currentTimeOnDemand / 60);
							var currentTimeSeconds = currentTimeOnDemand % 60;
							
							timeCurrentRep = ('0'+currentTimeMinutes).slice(-2)+':'+('0'+currentTimeSeconds).slice(-2);
						}
					
					if ( !mainthis.loadedVideo )
						{
							if ( !mainthis.startTimeRTMSeconds && !isEmpty(mainthis.rtmCodes) )
								{
									for ( var rtmTime in mainthis.rtmCodes )
										{
											for ( var b = 0; b<mainthis.rtmCodes[rtmTime].length; b++ )
												{
													if ( mainthis.rtmCodes[rtmTime][b].indexOf("217~@$") > -1 ) 
														{
															if ( !isFoundStart )
																{
																	isFoundStart = true;
																	var splitTime = rtmTime.split(":");
																	var startMinutes = parseInt(splitTime[0]) * 60;
																	mainthis.startTimeRTMSeconds = startMinutes + parseInt(splitTime[1]);
																	console.log('startTimeRTMSeconds', mainthis.startTimeRTMSeconds);
																	console.log('startTimeRTMSeconds1111', mainthis.rtmCodes[rtmTime][b]);
																}
														}
												}
										}
								}
								
							if ( mainthis.startTimeRTMSeconds || isEmpty(mainthis.rtmCodes) ) 
								{
									var videoTime = mainthis.startTimeRTMSeconds ? mainthis.startTimeRTMSeconds - fullSecondsCurrent : 0;
									
									if ( sessionData.ondemandId > 0 ) 
										{ 
											videoTime = 0; 
											if ( window['streamSwapped'] )
												{
													videoTime = swappedVideoTime ? swappedVideoTime : 0;
												}
										} 
									
									if ( videoTime >= 0 )
										{
											var videoURL = sessionData.replayVideo;
											if ( videoReplay.src == "" ) 
												{
													videoReplay.setAttribute("src", videoURL);
												}
											mainthis.loadedVideo = true;
											$('#replayClassVideo').removeClass('video_hidden');
											if ( isPlayedVideo ) { return false; }
											var currentVideoTime = videoTime;
											if ( currentVideoTime > videoReplay.duration ) { currentVideoTime = (videoReplay.duration - 0.1); }
											videoReplay.currentTime = currentVideoTime;
											videoReplay.play();
											isPlayedVideo = true;
											if ( window['sessionStartedBeforeMemberJoin'] )
												{
													window['sessionStartedBeforeMemberJoin']();		
												}
											
											videoReplay.onended = function (){
												if ( !mainthis.endReplayCalled && sessionData.replayClassId > 0 ) { mainthis.replayClassCompleted(); mainthis.endReplayCalled = true; console.log('checkSessionCompleted1'); }
											}
										}
								}			
						}
				
					//console.log('checking---replay', mainthis.rtmCodes, timeCurrentRep, mainthis.rtmCodes[timeCurrentRep]);
					if ( !isEmpty(mainthis.rtmCodes) && mainthis.rtmCodes[timeCurrentRep] != undefined && mainthis.previousRTMTime != timeCurrentRep && !videoReplay.paused )
						{
							for ( var i = 0; i < mainthis.rtmCodes[timeCurrentRep].length; i++ )
								{
									if ( !mainthis.rtmCodes[timeCurrentRep]['isSended'] )
										{
											mainthis.rtmCodes[timeCurrentRep]['isSended'] = [];
										}
									if ( mainthis.rtmCodes[timeCurrentRep]['isSended'].indexOf(i) == -1 )
										{
											if ( sessionData.replayClassId > 0 ) { mainthis.rtmCodes[timeCurrentRep]['isSended'].push(i); }
											console.log("rtmToSend---", mainthis.rtmCodes[timeCurrentRep][i], sessionData.hostId);
											window.onChannelMessage({text: mainthis.rtmCodes[timeCurrentRep][i], messageType: "TEXT"}, sessionData.hostEmail, true);
										}
								}	
						}
					else if ( !isEmpty(mainthis.rtmCodes) )
						{
							let ind = 0;
							var endRTMTime = '';
							
							if ( !mainthis.endTimeFound )
								{
									mainthis.lastTime = '';
									for ( var rtmTime in mainthis.rtmCodes )
										{
											/* if ( rtmTime > timeCurrent )
												{
													ind = rtmTime;
												}
											lastTime = rtmTime; */
											
											if ( endRTMTime == '' ) { endRTMTime = rtmTime; }
											if ( rtmTime < endRTMTime ) { endRTMTime = rtmTime; }
											
											var currentCode = JSON.stringify(mainthis.rtmCodes[rtmTime]);
											if ( currentCode.indexOf("306~@$") > -1 ) 
												{
													mainthis.lastTime = rtmTime; 
													console.log('lastTime', mainthis.lastTime); 
												}
											
											mainthis.endTimeFound = endRTMTime;
										}
										
									console.log('endRTMTime', mainthis.endTimeFound); 
								}
								
							let indexOf = ind;
							//if ( mainthis.rtmCodes[indexOf] ) 
							if ( mainthis.endTimeFound ) 
								{
									//lastCode = JSON.stringify(mainthis.rtmCodes[indexOf]);
									//if ( indexOf == lastTime || lastCode.indexOf("306~@$") > -1 )
										
									if ( timeCurrent < mainthis.endTimeFound || ( mainthis.lastTime && mainthis.lastTime != '' && timeCurrent < mainthis.lastTime ) )
										{
											checkSessionCompleted = indexOf;
											
											if ( !mainthis.endReplayCalled && sessionData.replayClassId > 0 ) { mainthis.replayClassCompleted(); mainthis.endReplayCalled = true; console.log('checkSessionCompleted2'); }
											return false;
										}
								
								/*
									for ( var i = 0; i < mainthis.rtmCodes[indexOf].length; i++ )
										{
											if ( !mainthis.rtmCodes[indexOf][i]['isSended'] )
												{
													mainthis.rtmCodes[indexOf][i]['isSended'] = true;
													console.log("rtmToSend---", mainthis.rtmCodes[indexOf][i], sessionData.hostId);
													window.onChannelMessage({text: mainthis.rtmCodes[indexOf][i], messageType: "TEXT"}, sessionData.hostEmail, true);
												}
										}	*/
								}
						}
						mainthis.previousRTMTime = timeCurrentRep;
				}
		}, 500); 
  }

	replayClassCompleted() {
		$.ajax({
			headers: { 
			  "Content-Type": "application/json; charset=utf-8",
			  "Authorization": JSON.parse(localStorage.getItem('userData')).token
			},
			url: process.env.REACT_APP_API_URL+'/api/v1/session/'+JSON.parse(localStorage.getItem('userData')).sessionData.id+'/completed',
			type: 'POST',
			data: JSON.stringify({'duration_session': window['countTimeSession'] ? window['countTimeSession'] : 0}),
			success: function( data, textStatus, jQxhr ){  
				console.log('checkSessionCompleted');
				window['leaveSession']();
			},
			error: function( jqXhr, textStatus, errorThrown ){
				console.log( errorThrown );
				window['leaveSession']();
			}
		});
	}
	
	openCloseAudio=()=>{
		var openAudioControlsVar = this.state.openAudioControls;
		openAudioControlsVar = !openAudioControlsVar;
		this.setState({openAudioControls: openAudioControlsVar, openVideoControls: false, openTestingMic: false, openMoreControls: false, openFms: false});
		this.props.updateStateFromChild({leaveSession: false});
	}
	
	openCloseVideo=()=>{
		var openVideoControlsVar = this.state.openVideoControls;
		openVideoControlsVar = !openVideoControlsVar;
		this.setState({openVideoControls: openVideoControlsVar, openAudioControls: false, openTestingMic: false, openMoreControls: false, openFms: false});
		this.props.updateStateFromChild({leaveSession: false});
	}
	
	openCloseMore=()=>{
		var openMoreControlsVar = this.state.openMoreControls;
		openMoreControlsVar = !openMoreControlsVar;
		this.setState({openMoreControls: openMoreControlsVar, openAudioControls: false, openTestingMic: false, openVideoControls: false, openFms: false});
		this.props.updateStateFromChild({leaveSession: false});
	}
	
	preventDef=(e)=>{
		e.preventDefault();
		e.stopPropagation();
	}
	
	disableCamera=(mod)=>{
		var cameraDisable = this.state.cameraDisableArray;
		if ( cameraDisable.indexOf(mod) > -1 )
			{
				
				cameraDisable.splice(cameraDisable.indexOf(mod), 1);
				
				if ( window['electron'] && cameraDisable.length == 2 )
					{
						window['globalAgora'].agora.enableLocalVideo(true);
					}
				
				if ( mod === "My Instructor (Trainer)" ) { window.switchVideoBroadcastingHost(1); }
				if ( mod === "Other Members" ) { window.switchVideoBroadcasting(1); }
				if ( mod === "Me (I dont't want to see myself)" ) 
					{
						window['userCameraOff'] = false;
						window['zoomParticipant'](0);
						if ( window['zoomedOption'] !== 3 )
							{
								$('#mine_stream').removeClass('d-none'); 
							}
						$('.video_icon .muted_audio').addClass('d-none');
						let switchHostParticipant = JSON.parse(localStorage.getItem('userData')).sessionData.switchHostParticipant;
						if ( switchHostParticipant != undefined && switchHostParticipant == 1 && window['hostInStreaming'] )
							{
								this.setState({
									cameraDisableArray: cameraDisable
								}, ()=> { 
									localStorage.setItem('turnOfCamera', JSON.stringify(cameraDisable));
									window.swapStreamVirtual(false, true, true, 'pip');}
								);
							}
					}
			}
		else
			{
				cameraDisable.push(mod);
				
				if ( window['electron'] && cameraDisable.length == 3 )
					{
						window['globalAgora'].agora.enableLocalVideo(false);
					}
				
				if ( mod === "My Instructor (Trainer)" ) { window.switchVideoBroadcastingHost(0); }
				if ( mod === "Other Members" ) { window.switchVideoBroadcasting(0); }
				if ( mod === "Me (I dont't want to see myself)" ) 
					{ 
						window['userCameraOff'] = true;
						if ( window['zoomedOption'] !== 3 )
							{
								$('#mine_stream').addClass('d-none'); 
							}
						$('.video_icon .muted_audio').removeClass('d-none');
						if ( window['streamSwapped'] )
							{
								window.swapStreamVirtual(true, true, true, 'pip');
							}
					}
			}
			
		this.setState({cameraDisableArray: cameraDisable});
		localStorage.setItem('turnOfCamera', JSON.stringify(cameraDisable));
	}
	
	saveEquipmentInfo = (statement, value)=>{
		axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/getBoxingPosition", { 'userId': this.state.currentUserData.id, 'equipmentStatement': statement, 'value': value }).then(res => {
		  
		var setBagPositions = res.data.responseData;
		var boxingPosition = setBagPositions['boxingPosition'] ? setBagPositions['boxingPosition'] : '';
		var boxingCirclePositions = setBagPositions['boxingCirclePosition'] ? setBagPositions['boxingCirclePosition'] : 1;
		var boxingPositionState;
		
		if ( boxingPosition != '' )
			{
				boxingPositionState = boxingPosition == 1 ? 'Right' : boxingPosition == 0 ? 'Left' : '';
			}
		else
			{
				boxingPositionState = '';
			}
			
		this.setState({
			boxingPosition: boxingPositionState,
			boxingCirclePosition: boxingCirclePositions
		},()=>{
			if ( window['updateBoxingCircle'] ) { window['updateBoxingCircle'](this.state.boxingCirclePosition); }
		});
		window['boxingCirclePosition'] = boxingCirclePositions;
		
		}).catch(err =>{ console.log('err'); });
	}
	
	updateSettings = (newState) => {
		this.setState(newState, () => {
			window['audioType'] = this.state.audioInstruction;
			window['boxingType'] = this.state.boxingPosition;
			window['bagPosition'] = this.state.bagPosition;
			window['changeBoxingPosition'](window['boxingType'], window['bagPosition']);
			var setAudioPar = window['audioType'] == 'longAudio' ? 1 : window['audioType'] == 'shortAudio' ? 2 : 0;
			var setBoxingPar = window['boxingType'] == 'ninetyDegrees' ? 1 : 0;
			var setBoxingPos = window['bagPosition'] == 'rightPosition' ? 1 : 0;
			var equipmentStatement = 'boxingPosition';
			this.saveEquipmentInfo('boxingCirclePosition', this.state.boxingCirclePosition);
			if ( window['updateBagPosition'] ) { window['updateBagPosition'](this.state.currentUserData.id, window['bagPosition']); }
			axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/updateVirtualInstruction", { 'voiceType': setAudioPar, 'boxingType': setBoxingPar, 'boxingPosition': setBoxingPos, 'userId': this.state.currentUserData.id, 'equipmentStatement': equipmentStatement  }).then(res => {
				 
			}).catch(err =>{ console.log('err'); }); 
			
		});
	}
	
	getBoxingPosition = () =>{
		axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/getBoxingPosition", { 'userId': this.state.currentUserData.id, 'equipmentStatement': 'hostInfo' }).then(res => {

		var setBagPositions = res.data.responseData;
		var setBagPosition = setBagPositions['boxingPosition'];
		console.log(setBagPosition, 'setBagPosition');
		if ( !setBagPosition || setBagPosition == '' ) { setBagPosition = 1; }
		window['bagPosition'] = setBagPosition == 1 ? 'rightPosition' : 'leftPosition';
		this.setState({ bagPosition: window['bagPosition'] });
		if ( setBagPositions['workoutConeLocation'] ) { window['workoutConePlacing'] = JSON.parse(setBagPositions['workoutConeLocation']); }
		if ( setBagPositions['boxJumpSize'] ) { this.setState({boxJumpSize: setBagPositions['boxJumpSize']}); }

		window['changeBoxingPosition'](window['boxingType'], window['bagPosition']);
		}).catch(err =>{ console.log('err'); }); 
	}
	
	openCloseMicTesting=()=>{
		var openTestingMicVar = this.state.openTestingMic;
		openTestingMicVar = !openTestingMicVar;
		this.setState({openTestingMic: openTestingMicVar});
		
		if ( !openTestingMicVar && !window['electron'] && this.state.isPlayedAudio === 1 )
			{
				this.startPlayingMicrophone();
			}

		if ( !openTestingMicVar && window['electron'] && this.state.isPlayedSpeaker === 1 )
			{
				this.stopPlayingSpeaker();
			}
	}
	
	startPlayingMicrophone = () => {
	 if ( this.state.isPlayedSpeaker === 1 || !window['main_mic_id_gue'] ) { return false; } 

	 if ( !window['electron'] )
		  {
			  if ( !this.audioTest ) { this.audioTest = document.createElement('audio'); }
			  
				if ( this.state.microphoneTestPart === 'start' )
					{
						navigator.mediaDevices.getUserMedia({ audio: { deviceId: { exact: window['main_mic_id_gue'].toString() } } }).then((stream) =>{
							if ("srcObject" in this.audioTest) { this.audioTest.srcObject = stream; } 
							else { this.audioTest.src = window.URL .createObjectURL(stream); } 
							var mainthis = this;
							this.audioTest.onloadedmetadata = function (ev) { this.play(); $('.audio_icon .muted_audio').removeClass('d-none'); };
							
							var audioContent = new AudioContext();
							var audioStream = audioContent.createMediaStreamSource(stream);
							var analyser = audioContent.createAnalyser();
							audioStream.connect(analyser);
							analyser.fftSize = 1024;

							var frequencyArray = new Uint8Array(analyser.frequencyBinCount);
							
							var visualizer = $("#playing_svg #visualizer")[0];
							visualizer.setAttribute("viewBox", "0 0 250 90");

							var path;
							for (var i = 0; i < 10; i++) {
							  path = document.createElementNS("http://www.w3.org/2000/svg", "path");
							  path.setAttribute("stroke-width", "10");
							  path.setAttribute("stroke", "white");
							  path.setAttribute("stroke-linecap", "round");
							  path.setAttribute("stroke-linejoin", "round");
							  visualizer.appendChild(path);
							}
							
							var paths = $("#playing_svg path");
							var doDraw = function() {
							  requestAnimationFrame(doDraw);
							  analyser.getByteFrequencyData(frequencyArray);
							  var adjustedLength;
							  for (var i = 1; i < 9; i++) {
								  
								adjustedLength = Math.floor((Math.floor(frequencyArray[i*20]) - Math.floor(frequencyArray[i*20]) % 5)/5);
								if ( adjustedLength == 0 ) { adjustedLength = 1; } 
								
								paths[i].setAttribute("d", "M " + (i*25) + ",45 l 0,-" + adjustedLength + " l 0," + (adjustedLength*2));
							  }
							};
							doDraw();
							
							
						});  
						
						this.setState({microphoneTestPart: 'playing_web', isPlayedAudio: 1});
						if ( !window['isMutedByMe'] )
							{
								if ( window['muteDuringMicTest'] )
									{
										window['muteDuringMicTest']('mute');
									}
							}
					}
					
				if ( this.state.microphoneTestPart === 'playing_web' )
					{
						this.audioTest.pause();  
						this.setState({microphoneTestPart: 'start', isPlayedAudio: 0});
						if ( !window['isMutedByMe'] )
							{
								$('.audio_icon .muted_audio').addClass('d-none');
								if ( window['muteDuringMicTest'] )
									{
										window['muteDuringMicTest']('unmute');
									}
							}
					}
		  }
	  else
		  {
			  if ( this.state.microphoneTestPart === 'start' )
				  {
					  var recordingfile = 'testRecording_'+(new Date().getTime())+'.aac';
					  var recPath = (osname === "Mac OS" ? '/tmp/' : './');
					  if ( window['recordingPath'] ) { recPath = window['recordingPath'].replace(/\\/g, '/')+'/'; }
				      var srec = window['globalAgora'].agora.startAudioRecording(recPath+recordingfile, 32000, 2);
					  this.setState({microphoneTestPart: 'recording', isPlayedAudio: 1});
					  if ( !this.mainSpeakerTestStream && window['main_mic_id_gue']  )
						{
							this.mainSpeakerTestStream = window.AgoraElectron.createStream({streamID: new Date().getTime(), audio: true, cameraId: 0, microphoneId: window['main_mic_id_gue'], video: false, screen: false });
						}
					  var mainthis = this;
					  if ( srec == 0 )
						  {
								window['globalAgora'].agora.muteLocalAudioStream(true);
								window['globalAgora'].agora.muteAllRemoteAudioStreams(true);
								$('.audio_icon .muted_audio').removeClass('d-none');
								setTimeout(() => {
									window['globalAgora'].agora.stopAudioRecording();
									setTimeout(() => {
											this.setState({microphoneTestPart: 'playing'}, () => {
												this.audioTest = document.createElement('audio'); 
												var audioTest2 = document.createElement('audio');
												this.audioTest.src = recPath+recordingfile;
												audioTest2.src = recPath+recordingfile;
												
												this.mainSpeakerTestStream.startAudioMixing({filePath: recPath+recordingfile, playTime: 0}, function(error) {
													if (error) {
														// Error handling
														return;
													}
												});
												
												this.audioTest.onloadedmetadata = function (ev)
													{
														mainthis.audioTest.play();
														var audioContent0 = (window.AudioContext || window.webkitAudioContext);
														var audioContent = new audioContent0();
														
														var audioStream = audioContent.createMediaElementSource(mainthis.audioTest);
														var analyser = audioContent.createAnalyser();
														audioStream.connect(analyser);
														analyser.fftSize = 1024;
														
														var frequencyArray = new Uint8Array(analyser.frequencyBinCount);
														var visualizer = $("#playing_svg #visualizer")[0];
														visualizer.setAttribute("viewBox", "0 0 250 90");
														
														var path;
														for (var i = 0; i < 10; i++) {
														  path = document.createElementNS("http://www.w3.org/2000/svg", "path");
														  path.setAttribute("stroke-width", "10");
														  path.setAttribute("stroke", "white");
														  path.setAttribute("stroke-linecap", "round");
														  path.setAttribute("stroke-linejoin", "round");
														  visualizer.appendChild(path);
														}
														
														var paths = $("#playing_svg path");
														
														var doDraw = function() {
														 if ( mainthis.state.isPlayedAudio == 0 ) { return false; }
														
														  requestAnimationFrame(doDraw);
														  analyser.getByteFrequencyData(frequencyArray);
														  var adjustedLength;
														  for (var i = 1; i < 9; i++) {
															  
															adjustedLength = Math.floor((Math.floor(frequencyArray[i*20]) - Math.floor(frequencyArray[i*20]) % 5)/5);
															if ( adjustedLength == 0 ) { adjustedLength = 1; }
															
															paths[i].setAttribute("d", "M " + (i*25) + ",45 l 0,-" + adjustedLength + " l 0," + (adjustedLength*2));
														  }
														};
														doDraw();
													}
													
													setTimeout(() => {
														this.audioTest.pause();
														this.setState({microphoneTestPart: 'start', isPlayedAudio: 0});
														if ( !window['isMutedByMe'] )
															{
																$('.audio_icon .muted_audio').addClass('d-none');
																window['muteDuringMicTest']('unmute');
															}
														
														if ( this.state.speakerMuted === false )
															{
																window.unmuteSpeaker();
															}
														else
															{
																mainthis.audioTest.stop();
																window.muteSpeaker();
															}
														
														if ( window['fsFile'] ) { try { window['fsFile'].unlink(recPath+recordingfile); } catch (err) { } }
														
														if ( $('#microphone-mute').attr('src') == 'images/voice-commands.png' ) 
															{
																window['globalAgora'].agora.muteLocalAudioStream(false);
															}

														window['globalAgora'].agora.muteAllRemoteAudioStreams(false);
														
													}, 5000);
												
											});
									}, 1000);
								}, 5000);	
						  }
				  }
		  }
	}
	
	startPlayingSpeaker = () => {
	  if ( this.state.isPlayedAudio === 1 ) { return false; } 
	  $('.audio_icon .muted_audio').removeClass('d-none');
	  if ( !this.mainSpeakerTestStream && window['main_mic_id_gue']  )
		{
			this.mainSpeakerTestStream = window.AgoraElectron.createStream({streamID: new Date().getTime(), audio: true, cameraId: 0, microphoneId: window['main_mic_id_gue'], video: false, screen: false });
		}
		
		window['globalAgora'].agora.muteLocalAudioStream(true);
		window['globalAgora'].agora.muteAllRemoteAudioStreams(true);
		
		var testPath = window['recordingPath'].replace(/\\/g, '/')+'/test_speaker.mp3';
		
		if ( window['fsFile'] && window['fsFile'].existsSync(window['applicationPath']+'/build/audio/test_speaker.mp3') && !window['fsFile'].existsSync(testPath)  )
			{
				window['fsFile'].copyFileSync(window['applicationPath']+'/build/audio/test_speaker.mp3', testPath);
			}

		var streamUrl = testPath;
		this.mainSpeakerTestStream.startAudioMixing({filePath: streamUrl, playTime: 0}, function(error) {
			if (error) {
				// Error handling
				return;
			}
		});
		
	  this.setState({speakerTestPart: 'playing', isPlayedSpeaker: 1});
	  
	  var mainthis = this;
	  
	  setTimeout(function(){ mainthis.stopPlayingSpeaker(); }, 5000);
	}
	
	stopPlayingSpeaker = () => {
		this.mainSpeakerTestStream.stopAudioMixing();	  
		this.setState({speakerTestPart: 'start', isPlayedSpeaker: 0});
		window['globalAgora'].agora.muteAllRemoteAudioStreams(false);
		if ( !window['isMutedByMe'] )
			{
				$('.audio_icon .muted_audio').addClass('d-none');
			}
	}
	
	showChat=()=>{
		if ( !this.props.chatOpen ) 
			{
				$('#chat_counter').text(0);
				$('#chat_counter').addClass('d-none');
				localStorage.removeItem('unreadMessagesNum');
				this.props.updateStateFromChild({rightMenuOpen: true, participantStatsOpen: false, activityListOpen: false, chatOpen: true});
			}
		else
			{
				this.props.updateStateFromChild({rightMenuOpen: false, chatOpen: false});
			}
	}
	
	retakeRoomSetup = () => {
	  console.log(this.state.currentUserData.id, 'RETAKE SETUP ID');
	  window['alreadyClickedOnSkip'] = false;
	  if ( window['scriptLoaded'] )
		{
			window.changeGlobalActType('', parseInt(this.state.currentUserData.id));
			this.setState({openMoreControls: false, openAudioControls: false, openTestingMic: false, openVideoControls: false});
			if ( !window['streamSwapped'] && !window['deviceNotSupported'] && !window['userCameraOff'] ) { window['swapStreamVirtual'](false); }
			//window['resetRoomSetup']();
			window['showCameraPopup']();
			window.pauseVirtualActivityStarted = false;
			
			if ( this.state.currentUserData.sessionData.ondemandId > 0 )
				{
					window.pauseVideo();
					$('.main_progress_container').addClass('disabled');
				}
			
			$('.redo_button').addClass('disabled');
			
			if ( window['userWhiteboard'][this.state.currentUserData.id] && window['userWhiteboard'][this.state.currentUserData.id].trackerActions.mediaPipeToggleTimeout )
				{
					clearTimeout(window['userWhiteboard'][this.state.currentUserData.id].trackerActions.mediaPipeToggleTimeout);
					window['userWhiteboard'][this.state.currentUserData.id].clearMessageInstructions();
					if ( window.disableCalculatingAR ) { window.disableCalculatingAR(); }
				}
		}
	}
	
	showParticipants=()=>{
		if ( !this.props.participantStatsOpen )
			{
				this.props.updateStateFromChild({rightMenuOpen: true, participantStatsOpen: true, activityListOpen: false, chatOpen: false});
				$('.controls_container').addClass('controls_container_less_padding');
				$('.control_container').addClass('control_less_padding');
			}
		else
			{
				this.props.updateStateFromChild({rightMenuOpen: false, participantStatsOpen: false, activityListOpen: false, chatOpen: false});
				$('.controls_container').removeClass('controls_container_less_padding');
				$('.control_container').removeClass('control_less_padding');
			}
	}
	
	openReactions=()=>{
		if ( !this.props.openReactions ) 
			{
				this.props.updateStateFromChild({openReactions: true, leaveSession: false});
			}
		else
			{
				this.props.updateStateFromChild({openReactions: false, leaveSession: false});
			}
	}
	
	openFms=()=>{
		var openFmsVar = this.state.openFms;
		openFmsVar = !openFmsVar;
		this.setState({openAudioControls: false, openVideoControls: false, openTestingMic: false, openMoreControls: false, openFms: openFmsVar});
		this.props.updateStateFromChild({leaveSession: false});
	}
	
	openLeaveSession=()=>{
		this.setState({openAudioControls: false, openVideoControls: false, openTestingMic: false, openMoreControls: false});
		this.props.updateStateFromChild({leaveSession: true, openReactions: false});
	}
	
	changeResolutionTo = (newres) => {
		var mainThis = this;
		window['currentResolution'] = newres;
		this.setState({
			currentResolution: newres
		});
		
		if ( newres == 'sd' )
			{
				window['globalAgora'].agora.setVideoEncoderConfiguration({'width': 640, 'height': 360, 'frameRate': 30});
				setTimeout(function () { mainThis.applyCameraRestrict(); }, 3000);
			}
		else if ( newres == 'hd' )
			{
				window['globalAgora'].agora.setVideoEncoderConfiguration({'width': 1280, 'height': 720, 'frameRate': 30});
				setTimeout(function () { mainThis.applyCameraRestrict(); }, 3000);
			}
		else if ( newres == 'hdp' )
			{
				window['globalAgora'].agora.setVideoEncoderConfiguration({'width': 1920, 'height': 1080, 'frameRate': 30});
				setTimeout(function () { mainThis.applyCameraRestrict(); }, 3000);
			}
			
		let sendVideoInfo = newres;
		let sendVideo = sendVideoInfo == 'hd' ? 1 : sendVideoInfo == 'sd' ? 0 : 2; 
		
		let varId = this.state.currentUserData.id;
		if ( window['resetWhiteDrawSkip'+varId] ) 
			{ 
				window['resetWhiteDrawSkip'+varId](varId); 
			}
		
		axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/changeCustomResolution", { 'resolution': sendVideo, 'userId': this.state.currentUserData.id  }).then(res => {
			 
		}).catch(err =>{ console.log('err'); }); 
	}
	
	applyCameraRestrict = () => {
		console.log('participant controls white cam start');
		let currentCameraId = JSON.parse(localStorage.getItem('media-setting'));
		if ( window['electron'] && window.whiteCam && window.whiteCam.addOn && window.whiteCam.addOn.CameraChange && currentCameraId && window.currentUserData && window.currentUserData.default && parseInt(window.currentUserData.default.useCameraZoomLock) )
			{
				var currentCamera = currentCameraId['camera'];
				if( currentCamera )
					{
						window.whiteCam.addOn.CameraChange(currentCamera);
						console.log('participant controls white cam changed---', currentCamera);
					}
			}
	}
	
	getVideoResolution = () => {
	  var videoInfo;
	  var putVideoInfo;
	  axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/getCustomResolution", { 'userId': this.state.currentUserData.id  }).then(res => {
			videoInfo = res.data.responseData.videoResolutionParticipant;
			console.log(videoInfo, 'videoInfo');
			putVideoInfo = videoInfo == 1 ? 'hd' : videoInfo == 0 ? 'sd' : 'hdp';
			this.setState({
				currentResolution: putVideoInfo
			});
			this.changeResolutionTo(putVideoInfo);
		}).catch(err =>{ console.log('err--', err); }); 
	}
	
	saveBoxOptions=(mod, value)=>{
		this.setState({
			[mod]: value
		},()=>{this.saveBoxJump();});
	}
	
	saveBoxJump=()=>{
		var insertValue = this.state.boxJumpWidth+'x'+this.state.boxJumpHeight;
		axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/getBoxingPosition", { 'userId': this.state.currentUserData.id, 'equipmentStatement': 'boxJumpSize', 'value': insertValue  }).then(res => {
			var boxJumpData = res.data.responseData;
			var setBoxJumpSize = boxJumpData['boxJumpSize'] ? boxJumpData['boxJumpSize'] : '';
			console.log(setBoxJumpSize, 'setBoxJumpSize');
			this.setState({
				boxJumpSize: setBoxJumpSize
			});
			
			if ( setBoxJumpSize == '' )
				{
					var dimensionWidth = 14;
					var dimensionHeight = 14;
				}
			else
				{
					var dimensions = setBoxJumpSize.split("x");
					var dimensionWidth = dimensions[0];
					var dimensionHeight = dimensions[1];
				}
			
			window['boxJumpSize'] = setBoxJumpSize;
			
			this.setState({
				boxJumpWidth: dimensionWidth,
				boxJumpHeight: dimensionHeight
			});
			
			window['boxJumpWidth'] = dimensionWidth*7;
			window['boxJumpHeight'] = dimensionHeight*7;
			
			var sep = '~@$';
			window['globalRTM'](this.state.currentUserData['sessionData']['hostEmail'], 'sendBoxInfo'+sep+window['boxJumpSize']+sep+window['useEquipmentLocation']);
			
		}).catch(err =>{ console.log('err'); });
	}
	
	openZoomNote=(mod)=>{
		let notesArray = window['fmsNotes'];
		this.setState({
			openFms: false
		});
		
		this.props.updateStateFromChild({participantNotes: notesArray, choosenNoteNum: mod, openFmsNote: true,});
	}
	
	showBigCountdown=(mod)=>{
		
		if ( this.state.currentUserData.isMarketplaceChannel == 0 )
			{ 
				return false;
			}
		
		
		this.setState({
			showBigClock: true,
		}, ()=>{
			let mainthis = this;
			mainthis.startInterval();
			setTimeout(function(){
				mainthis.setState({
					showBigClock: false,
				});
				clearInterval(this.countInterval);
				}, 10000)
		});
		
	}
	
	startInterval=()=>{
		let mainthis = this;
		this.countInterval = setInterval(function() {
			let countNum = mainthis.state.countSecs;
			countNum = countNum - 1;
			if ( countNum > -1 )
				{
					mainthis.setState({
						countSecs: countNum,
						});
				}
			else 
				{
					mainthis.setState({
						showBigClock: false,
						});
				}				
			}, 1000);
	}
	
	changeVolumeFm=(e, mod)=>{
		if (mod == undefined)
			{
				let value = e.target.value;
				this.setState({[e.target.id]: e.target.value}, ()=>{
					window['changeFmVolumeHost'](value);
				});
			}
		else 
			{
				this.setState({fmVolume: mod}, ()=>{
					window['changeFmVolumeHost'](mod);
				});
			}
	}
	
	changeVolumeHost=(e)=>{
		this.setState({[e.target.id]: e.target.value});
		window['reduceHostVolume'](parseInt(e.target.value));
	}
	
	render() {
		return (
			<div className="controls_container"  className={"controls_container " + ( this.state.isEndedSession ? "end_class_font" : "" ) } ref={this.wrapperRef} id="memberControlsHolder">
				{ !this.state.currentUserData.sessionData.ondemandId &&
					<div className={"session_time " + ( this.state.isEndedSession ? "ended_session" : "" ) }>{this.state.sessionTime}
						<div className="abs_border"></div>
					</div>
				}
				{/*this.state.showBigClock && 
					<div className="bigCountShow" >
						<div className="countNumD2C" >{this.state.countSecs}</div>
					</div>
				*/}
				{ !this.state.currentUserData.sessionData.ondemandId &&
					<div className={"control_container menu_hidden_item " + (this.state.openAudioControls ? 'active' : '')}  id="micSettingsPop" onClick={this.openCloseAudio}>
						<div className="control_icon audio_icon">
							<div className="control_arrow"></div>
							<div className="muted_audio"></div>
						</div>
						<div className="control_title">Audio</div>
						<div className={"control_drop " + ( !this.state.openAudioControls ? "d-none" : "" ) } onClick={this.preventDef}>
							<div className={( this.state.openTestingMic ? "d-none" : "" ) }>
								<div className="drop_container">
									<div className="drop_title">Select a Microphone</div>
									<div id="microphone_options"></div>
								</div>
								<div className="drop_container d-none" id="mic_control">
									<div className="mic_icon">
										<div className="muted_audio d-none"></div>
									</div>
									<div className="test_title_streaming" id="microphone_control">Mute Microphone</div>
								</div>
								{ this.props.isPlayingFM && !this.state.hideFmControls &&
									<div id="music_control">
										<div className="drop_container">
											<div className="one_feed_control">
												<div className="test_title_streaming">Instructor</div>
												<div className="range_feed_content">
													<div className="relative_range">
														<input type="range" className="range_fm" id="volumeHost" value={this.state.volumeHost} name="volume "min="0" max="100" onChange={this.changeVolumeHost} />
													</div>
													<div className="fm_music_icon"></div>
												</div>
											</div>
										</div>
										{/*
										<div className="drop_container">
											<div className="one_feed_control">
												<div className="test_title_streaming">Music</div>
												<div className="range_feed_content">
													<div className="relative_range">
														<input type="range" className="range_fm w100" id="volumeFM" value={this.state.volumeFM} name="volume "min="0" max="100" onChange={this.changeVolumeFm} />
													</div>
													<div className="fm_music_icon"></div>
												</div>
											</div>
										</div>
										*/}
									</div>
								}
								<div className={( !this.state.isElectron ? "d-none" : "" ) }>
									<div className="drop_container">
										<div className="drop_title">Select a Speaker</div>
										<div id="speaker_options"></div>
									</div>
								</div>
								<div className="drop_container" id="speak_control">
									<div className="mic_icon speak_icon">
										<div className="muted_audio d-none"></div>
									</div>
									<div className="test_title_streaming" id="speaker_control">Mute Speaker</div>
								</div>
								<div className="drop_container no_border" id="test_part" onClick={this.openCloseMicTesting}>
									<div className="test_title_streaming">{this.state.isElectron ? 'Test Speaker and Microphone' : 'Test Microphone'}</div>
								</div>
							</div>
							<div className={( !this.state.openTestingMic ? "d-none" : "" ) }>
								<div className="drop_container">
									<div className="drop_title">Microphone
										<div className="drop_close" onClick={this.openCloseMicTesting}></div>
										{ this.state.microphoneTestPart === 'start' &&
											<div className="testing_container" onClick={this.startPlayingMicrophone}>
												<div className="mic_test_icon"></div>
												<div className="test_text">Test</div>
											</div>
										}
										{ (this.state.microphoneTestPart === 'playing_web' || this.state.microphoneTestPart === 'playing') &&
											<div className="testing_container" id="playing_svg" onClick={this.state.microphoneTestPart === 'playing_web' ? this.startPlayingMicrophone : {}}>
												<div className="mic_test_icon"></div>
												<svg className="svg_visualizer" preserveAspectRatio="none" id="visualizer" version="1.1" xmlnsXlink="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink"></svg>
											</div>
										}
										{ this.state.microphoneTestPart === 'recording' &&
											<div className="testing_container">
												<div className="mic_test_icon"></div>
												<div className="test_text">Speak into Mic now...</div>
											</div>
										}
									</div>	
								</div>
								{ this.state.isElectron &&
									<div className="drop_container" id="speaker_control">
										<div className="drop_title">Speaker</div>
										{ this.state.speakerTestPart === 'start' &&
											<div className="testing_container" onClick={this.startPlayingSpeaker}>
												<div className="mic_test_icon speak_icon"></div>
												<div className="test_text">Test</div>
											</div>
										}
										{ this.state.speakerTestPart === 'playing' &&
											<div className="testing_container">
												<div className="mic_test_icon speak_icon"></div>
												<div className="test_text">Playing...</div>
											</div>
										}
									</div>
								}
							</div>
						</div>
					</div>
				}
				<div className={"control_container menu_hidden_item " + (this.state.openVideoControls ? 'active' : '')} onClick={this.openCloseVideo} id="cameraSettingsPop" >
					<div className="control_icon video_icon">
						<div className="control_arrow"></div>
						<div className={"muted_audio " + (!window['cameraFoundStatus'] ? "": "d-none")}></div>
					</div>
					<div className="control_title">Video</div>
					<div className={"control_drop " + ( !this.state.openVideoControls ? "d-none" : "" ) } onClick={this.preventDef}>
						<div id='showCameraOptions'>
							<div className="drop_container">
								<div className="drop_title">Select a Camera</div>
								<div id="camera_options"></div>
							</div>
							<div className={"drop_container " + ( !this.state.isElectron ? "d-none" : "" ) }>
								<div className="drop_title">Camera Resolution</div>
								<div className={"drop_option " + (!window['cameraFoundStatus'] ? "d-none" : "")} onClick={() => this.changeResolutionTo("sd")}>SD
									{ this.state.currentResolution == 'sd' &&
										<div className="drop_checked"></div>
									}
								</div>
								<div className={"drop_option " + (!window['cameraFoundStatus'] ? "d-none" : "")} onClick={() => this.changeResolutionTo("hd")}>HD
									{ this.state.currentResolution == 'hd' &&
										<div className="drop_checked"></div>
									}
								</div>
								<div className={"drop_option " + (!window['cameraFoundStatus'] ? "d-none" : "")} onClick={() => this.changeResolutionTo("hdp")}>HD+
									{ this.state.currentResolution == 'hdp' &&
										<div className="drop_checked"></div>
									}
								</div>
							</div>
							<div className="drop_container no_border">
								<div className="drop_title">Camera Permissions</div>
								{ !this.state.currentUserData.sessionData.ondemandId &&
									<>
										<div className={"drop_option " + (!window['cameraFoundStatus'] ? "d-none" : "")} onClick={() => this.disableCamera("My Instructor (Trainer)")}>Disable for Instructor
											{ this.state.cameraDisableArray.indexOf("My Instructor (Trainer)") > -1 &&
												<div className="drop_checked"></div>
											}
										</div>
										<div className={"drop_option " + (!window['cameraFoundStatus'] ? "d-none" : "")} onClick={() => this.disableCamera("Other Members")}>Disable for Members
											{ this.state.cameraDisableArray.indexOf("Other Members") > -1 &&
												<div className="drop_checked"></div>
											}
										</div>
									</>
								}
								<div className={"drop_option " + (!window['cameraFoundStatus'] ? "d-none" : "")} onClick={() => this.disableCamera("Me (I dont't want to see myself)")}>Disable for Me
									{ this.state.cameraDisableArray.indexOf("Me (I dont't want to see myself)") > -1 &&
										<div className="drop_checked"></div>
									}
								</div>
							</div>
						</div>
						<div id="cameraDisableHold" className="drop_title camera_hold_disable d-none">Camera Change is not available when the Virtual is loaded.</div>
					</div>
				</div>
				{ !this.state.currentUserData.sessionData.ondemandId &&
					<div className="control_container menu_hidden_item" onClick={this.showChat}>
						<div className="control_icon chat_icon"></div>
						<div className="control_title">Chat</div>
						<div className="control_counter d-none" id="chat_counter">0</div>
					</div>
				}
				{ !this.state.currentUserData.sessionData.ondemandId &&
					<div className="control_container menu_hidden_item" id="member_control" onClick={this.showParticipants}>
						<div className="control_icon participants_icon">
							<div className="control_counter partNumPos d-none" id="participants_counter">1</div>
						</div>
						<div className="control_title">Members</div>
					</div>
				}
				{ this.state.currentUserData.isMarketplaceChannel == 0 &&
					<div className="control_container menu_hidden_item" id="raise_hand" onClick={this.props.raiseHand}>
						<div className="control_icon hand_icon"></div>
						<div className="control_title">Raise Hand</div>
					</div>
				}
				{ !this.state.currentUserData.sessionData.ondemandId &&
					<div className="control_container menu_hidden_item" id="reactions_control" onClick={this.openReactions}>
						<div className="control_icon smyle_icon"></div>
						<div className="control_title">Reactions</div>
					</div>
				}
				<div className="control_container menu_hidden_item d-none" id="fms_control" onClick={this.openFms}>
					<div className="control_icon fms_icon">
						<div className="control_counter partNumPos" id="fms_images">0</div>
					</div>
					<div className="control_title">FMS</div>
					{ this.state.openFms && 
						<div className={"control_drop control_drop_padding "} onClick={this.preventDef}>
							<div className="fmsTitle" >Feedback</div>
							{ window['fmsNotes'] &&
								<div>
									<FmsNotes  
										openZoomNote={this.openZoomNote}
									></FmsNotes>
								</div>
							}
						</div>
					}	
				</div>
				{/* <div className="control_container" id="zoom_option">
					<div className="control_icon zoom_icon"></div>
					<div className="control_title">Zoom</div>
				</div> */ }
				<div className={"control_container menu_hidden_item " + (this.state.openMoreControls ? 'active' : '')} onClick={this.openCloseMore}>
					<div className="abs_border"></div>
					<div className="control_icon more_icon"></div>
					<div className="control_title">More</div>
					<div className={"control_drop more_settings_hold " + ( !this.state.openMoreControls ? "d-none" : "" ) } onClick={this.preventDef}>
						{ !window['hasVirtualEquipment'] && !this.state.hasBoxing && !this.state.hasBoxJump &&
							<div className="drop_container">
								<div className="drop_title no_available">No Available Options</div>
							</div>
						}
						{window['hasVirtualEquipment'] &&
							<div className="drop_container">
								<div className="drop_title">Audio Instructions for Virtual Activities</div>
								<div className="drop_option" id="audioInstruction" onClick={(e) => this.updateSettings({[e.target.id]: 'longAudio'})}>Detailed instructions
									{ this.state.audioInstruction == 'longAudio' &&
										<div className="drop_checked"></div>
									}
								</div>
								<div className="drop_option" id="audioInstruction" onClick={(e) => this.updateSettings({[e.target.id]: 'shortAudio'})}>Short Instructions
									{ this.state.audioInstruction == 'shortAudio' &&
										<div className="drop_checked"></div>
									}
								</div>
								<div className="drop_option" id="audioInstruction" onClick={(e) => this.updateSettings({[e.target.id]: 'offAudio'})}>Off
									{ this.state.audioInstruction == 'offAudio' &&
										<div className="drop_checked"></div>
									}
								</div>
							</div>
						}
						{/* <div className="drop_container">
							<div className="drop_title">Boxing Circle Position</div>
							<div className="drop_option" id="boxingPosition" onClick={(e) => this.updateSettings({[e.target.id]: 'ninetyDegrees'})}>90 degrees
								{ this.state.boxingPosition == 'ninetyDegrees' &&
									<div className="drop_checked"></div>
								}
							</div>
							<div className="drop_option" id="boxingPosition" onClick={(e) => this.updateSettings({[e.target.id]: 'fourtyFiveDegrees'})}>45 degrees
								{ this.state.boxingPosition == 'fourtyFiveDegrees' &&
									<div className="drop_checked"></div>
								}
							</div>
						</div> */}
						{ this.state.hasBoxing &&
							<>
							<div className="drop_container">
								<div className="drop_title">Boxing Bag Position</div>
								<div className="drop_option" id="bagPosition" onClick={(e) => this.updateSettings({[e.target.id]: 'leftPosition'})}>Left
									{ this.state.bagPosition == 'leftPosition' &&
										<div className="drop_checked"></div>
									}
								</div>
								<div className="drop_option" id="bagPosition" onClick={(e) => this.updateSettings({[e.target.id]: 'rightPosition'})}>Right
									{ this.state.bagPosition == 'rightPosition' &&
										<div className="drop_checked"></div>
									}
								</div>
							</div>
							<div className="drop_container">
								<div className="drop_title">Boxing Circle Position</div>
								<div className="drop_option" id="boxingCirclePosition" onClick={(e) => this.updateSettings({[e.target.id]: 1})}>90 Degrees
									{ this.state.boxingCirclePosition == 1 &&
										<div className="drop_checked"></div>
									}
								</div>
								<div className="drop_option" id="boxingCirclePosition" onClick={(e) => this.updateSettings({[e.target.id]: 0})}>45 Degrees
									{ this.state.boxingCirclePosition == 0 &&
										<div className="drop_checked"></div>
									}
								</div>
							</div>
							</>
						}
						{ this.state.hasBoxJump &&
							<div className="drop_container box_jump_container">
								<div className="drop_title">Box Horizontal Size</div>
								<select className="drop_option drop_select" id="boxJumpWidth" onChange={(e) => this.saveBoxOptions(e.target.id, e.target.value)} value={this.state.boxJumpWidth}>
									{ this.state.boxJumpOptions.map((item, key) => 
										<option value={item} key={key}>{item}</option>
									)}
								</select>
								<div className="select_title_room">in W</div>
								<div></div>
								<select className="drop_option drop_select" id="boxJumpHeight" onChange={(e) => this.saveBoxOptions(e.target.id, e.target.value)} value={this.state.boxJumpHeight}>
									{ this.state.boxJumpOptions.map((item, key) => 
										<option value={item} key={key}>{item}</option>
									)}
								</select>
								<div className="select_title_room">in H</div>
							</div>
						}
						{ !window['userCameraOff'] && window['roomSetDone'] && !window['showMemerFitnessScript'] &&
							<div className="drop_container">
								<div className="stream_confirm_btn redo_button" onClick={this.retakeRoomSetup}>Redo Room Setup</div>
							</div>
						}
					</div>
				</div>
				<div className="control_container menu_hidden_item" onClick={this.openLeaveSession}>
					<div className="control_icon leave_icon"></div>
					<div className="control_title">Leave Class</div>
				</div>
			</div>
	)}
}
export default ParticipantControls;
